module.exports = __webpack_public_path__ + "img/mask_down.4226977d.png";